<template>
    <div class="no-pay-popup" @click.self="close">
        <div class="main">
            <img class="close" @click="close" src="https://appd.knowbox.cn/ss/activity/common/icon_popup_close.png"/>
            <img class="no-pay-ele" src="https://appd.knowbox.cn/ss/activity/member/no_pay_ele.png" alt="">
            <p class="title">确定放弃{{ needUpgrade == 0 ?  '开通' : '升级' }}会员吗？</p>
            <p class="subtitle">你可能会错过</p>
            <div class="course">
                <div>
                    <img src="https://appd.knowbox.cn/ss/activity/member/member_ rights_icon_1.png" alt="">
                    <span>轻课音频免费学</span>
                </div>
                <div>
                    <img src="https://appd.knowbox.cn/ss/activity/member/member_ rights_icon_2.png" alt="">
                    <span>同步练免费练</span>
                </div>
                <div>
                    <img src="https://appd.knowbox.cn/ss/activity/member/member_ rights_icon_3.png" alt="">
                    <span>阅读绘本免费读</span>
                </div>
            </div>
            <button @click="pay">立即{{ needUpgrade == 0 ?  '开通' : '升级' }}</button>
        </div>
    </div>
</template>

<script>
import utils from "@/assets/js/utils";
const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
export default {
  name: "",
  props: {
    // 是否升级,1是 0否,如果是1时
    needUpgrade: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {};
  },
  created() {
    utils.sendLog(
        {
            token: token,
            version: version,
            source: source
        },
        "vipCancleOpen_show"
    );
  },
  methods: {
    pay() {
      utils.sendLog(
        {
            token: token,
            version: version,
            source: source,
        },
        "vipCancleOpen_open_click"
      );
      this.$emit("pay");
    },
    close() {
      utils.sendLog(
        {
            token: token,
            version: version,
            source: source,
        },
        "vipCancleOpen_cancel_click"
      );
      console.log('close');
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.no-pay-popup {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.8);
  position: fixed;
  top: 0;
  left: 0;
  .main {
    position: absolute;
    top: calc(50% + 0.94rem);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5.8rem;
    height: 6.2rem;
    border-radius: 0.3rem;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .no-pay-ele {
      position: absolute;
      width: 2.91rem;
      height: 1.88rem;
      top: -1.88rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .title {
      font-family: "PingFang-SC-Bold";
      font-size: 0.36rem;
      line-height: 0.4rem;
      color: #424243;
      height: 0.4rem;
      margin-top: 0.48rem;
      font-weight: bolder;
    }
    .subtitle {
      font-family: "PingFangSC-Regular";
      font-size: 0.28rem;
      line-height: 0.28rem;
      height: 0.28rem;
      color: #bec0c2;
      margin-top: 0.17rem;
    }
    .course {
      font-size: 0.32rem;
      color: #7b531e;
      height: 2.66rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      margin-top: 0.31rem;
      font-weight: bolder;
      div {
        display: flex;
        align-items: center;
        img {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.26rem;
        }
      }
    }
    button {
      width: 4.4rem;
      height: 0.88rem;
      border-radius: 0.44rem;
      font-family: "PingFangSC-Medium";
      font-size: 0.32rem;
      color: #7b531e;
      margin-top: 0.56rem;
      background-image: linear-gradient(
        to right,
        rgb(233, 205, 149),
        rgb(241, 219, 178)
      );
    }
    .close {
      width: 0.61rem;
      height: 0.62rem;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>